var Stream = (function (){
  try {
    return require('st' + 'ream'); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

if (!process.browser && process.env.READABLE_STREAM === 'disable' && Stream) {
  module.exports = Stream;
}



/*****************
 ** WEBPACK FOOTER
 ** ../~/readable-stream/readable.js
 ** module id = 995
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/readable-stream/readable.js
 ** module id = 995
 ** module chunks = 1
 **/